import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

const defaultProps = {};

export default function ModalHeaderTitle({title, subtitle}) {
  return (
    <React.Fragment>
      <h4>
        {title}
      </h4>
      {!!subtitle && <p style={{
        fontFamily: "var(--font-family-base)",
        fontSize: "1rem"
      }} className="content-spacer-top font-weight-normal mb-0">
        {subtitle}
      </p>}
    </React.Fragment>
  );
}

ModalHeaderTitle.propTypes = propTypes;
ModalHeaderTitle.defaultProps = defaultProps;